import router from '../router'
import axios from 'axios' //引入 axios
import { G } from 'core-js/modules/_export';
import { AesDecrypt, requestKeyMap } from './rsa'

// 创建 axios 实例
const service = axios.create({
	// baseURL: '/xinyidai', // 加/xinyidai/前缀
	baseURL: '', // 不加/xinyidai/前缀
	timeout: 60000, // 请求超时时间
})
//请求头 token 封装
service.defaults.headers.post['Content-Type'] = 'application/json';
service.interceptors.request.use(
	config => {
		if (sessionStorage.getItem('token')) {
			//token字段是要和后端协商好的
			config.headers.common["token"] = sessionStorage.getItem('token');
			// debugger
		}
		// 同源密钥串联：从请求体取出本次请求生成的对称密钥 K，挂到请求配置上，供响应拦截器使用
		const body = config.data
		if (body && typeof body === 'object' && body.requestData && requestKeyMap[body.requestData]) {
			config.__aesKey = requestKeyMap[body.requestData]
			delete requestKeyMap[body.requestData]
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	});

// http response 拦截器
service.interceptors.response.use(
	response => {
		if (response.data.code == 999) {
			sessionStorage.clear()
			router.replace({
				path: "/",
				query: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		// 同源密钥解密：用请求阶段生成的对称密钥 K 解密响应（前端不再持有客户端私钥）
		const aesKey = response.config && response.config.__aesKey
		if (aesKey && response.data && response.data.requestData) {
			try {
				const plain = AesDecrypt(response.data.requestData, aesKey)
				response.data = JSON.parse(plain)
			} catch (e) {
				// 解密失败保持原样，交由业务层处理
			}
		}
		return response;
	},
	error => {
		return Promise.reject(error)
	}
)


export function get (url, params = {}) { //get 封装
	return new Promise((resolve, reject) => {
		service.get(url, {
			params: params
		}).then(response => {
			resolve(response.data);
		}).catch(err => {
			reject(err)
		})
	})


}

export function post (url, data = {}) { //post封装
	return new Promise((resolve, reject) => {
		service.post(url, data)
		
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

export default service